module.exports = __webpack_public_path__ + "img/1440.e1557f70.jpg";